// extracted by mini-css-extract-plugin
export default {"name":"header_name__Jzl6G","options":"header_options__7d6CU","menu":"header_menu__bsN3F","background-body":"header_background-body__3srwy"};